import { findCompanyBySlug } from '../../../client-experience/utils/companyAccess';

export const getStorefrontAccountBase = (companyUrl) => `/book/${companyUrl}/account`;

export const getStorefrontAccountAppointmentsPath = (companyUrl) =>
  `${getStorefrontAccountBase(companyUrl)}/appointments`;

/** Default landing tab after sign-in (appointments list). */
export const getStorefrontAccountHomePath = (companyUrl) =>
  getStorefrontAccountAppointmentsPath(companyUrl);

/**
 * Public-facing appointment URL segment (no Firestore doc id when possible).
 * Resolution uses client-scoped queries + in-memory match in resolveClientPortalAppointmentSnapshot.
 */
export const getAppointmentUrlSegment = (appointment) => {
  if (!appointment) return '';
  if (appointment.shortSlug) return String(appointment.shortSlug);
  if (appointment.publicNumber != null && appointment.publicNumber !== '') {
    return String(appointment.publicNumber);
  }
  return appointment.id || '';
};

export const isFirestoreAppointmentDocId = (value) => {
  const s = String(value || '');
  return s.length >= 18 && /^[a-zA-Z0-9]+$/.test(s);
};

export const getStorefrontAppointmentDetailPath = (companyUrl, appointmentOrId) => {
  const segment = typeof appointmentOrId === 'string'
    ? appointmentOrId
    : getAppointmentUrlSegment(appointmentOrId);
  return `${getStorefrontAccountBase(companyUrl)}/appointments/${segment}`;
};

export const getStorefrontAppointmentCancelConfirmationPath = (companyUrl, appointmentOrId) => {
  const segment = typeof appointmentOrId === 'string'
    ? appointmentOrId
    : getAppointmentUrlSegment(appointmentOrId);
  return `${getStorefrontAccountBase(companyUrl)}/appointments/${segment}/cancel-confirmation`;
};

export const resolveClientPortalCompanyUrl = ({ companyUrl, appointment } = {}) => (
  companyUrl
  || (typeof window !== 'undefined' ? localStorage.getItem('clientPortalUrl') : '')
  || appointment?.portalUrl
  || appointment?.companyUrl
  || ''
);

export const resolveClientPortalCompanyId = async ({ appointment, companyUrl } = {}) => {
  if (appointment?.companyId) {
    return appointment.companyId;
  }

  const stored = typeof window !== 'undefined' ? localStorage.getItem('clientCompanyId') : '';
  if (stored) {
    return stored;
  }

  const slug = companyUrl || resolveClientPortalCompanyUrl({ appointment });
  if (!slug) {
    return null;
  }

  const company = await findCompanyBySlug(slug);
  return company?.id || null;
};

export const canClientCancelAppointment = (appointment) => {
  if (!appointment) return false;
  if (appointment.isPendingRecord) return false;
  if (appointment.isArchived) return false;

  const status = String(appointment.status || '').toLowerCase();
  return status !== 'cancelled' && status !== 'completed';
};
